import { CSSProperties, useMemo } from "react";
import {
  StyledMiniListCard,
  StyledMiniListFooter,
  StyledMiniListList,
} from "./index.styled";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";
import { StyledFlex } from "../../Table/index.styled";
import { ActionButton } from "../../Buttons";

type Data = {
  title: string | JSX.Element;
  description: string | JSX.Element;
  avatar: string | JSX.Element;
  onClick?: () => void;
};

export type MiniListProps = {
  title: string;
  data: Data[];
  refetch?: () => void;
  loading?: boolean;
  extra?: string | JSX.Element;
  height?: string | number;
  heightFull?: boolean;
  footer?: string | JSX.Element;
  cardProps?: AppCardProps;
  style?: CSSProperties;
};

const MiniList = (props: MiniListProps) => {
  const {
    title,
    data,
    refetch,
    loading,
    extra,
    heightFull = false,
    footer,
    height,
    cardProps,
    style,
  } = props;

  const dataSource: Data[] = useMemo(() => {
    return data.map((item) => ({
      avatar: item.avatar,
      title: item.title,
      description: item.description,
      onClick: item.onClick,
    }));
  }, [data]);

  return (
    <StyledMiniListCard
      title={title}
      extra={
        <StyledFlex style={{ gap: 10 }}>
          {extra}
          {refetch && (
            <ActionButton
              type="refresh"
              noLabel
              noBg
              size="small"
              onClick={() => refetch()}
              disabled={loading}
              loading={loading}
            />
          )}
        </StyledFlex>
      }
      height={height}
      heightFull={heightFull}
      actions={
        footer ? [<StyledMiniListFooter>{footer}</StyledMiniListFooter>] : []
      }
      useFooter={!!footer}
      {...cardProps}
      style={style}
    >
      <StyledMiniListList
        size="small"
        dataSource={dataSource}
        renderItem={(item: Data, index) => (
          <StyledMiniListList.Item key={index} onClick={item.onClick}>
            <StyledMiniListList.Item.Meta
              avatar={item.avatar}
              title={item.title}
              description={item.description}
            />
          </StyledMiniListList.Item>
        )}
      />
    </StyledMiniListCard>
  );
};

export default MiniList;
